import * as React from "react";
import { onError } from "src/common/onError";
import { ZSidLabel } from "src/types";

import { loadValueCatalog } from "../apiValueCatalog";
import {
  PropsSelectValueCatalog,
  SelectValueCatalog,
} from "./SelectValueCatalog";

type PropsSelectValueCatalogId = Omit<
  PropsSelectValueCatalog,
  "onChange" | "value"
> & {
  value?: string;
  onChange?(newValue?: string): void;
};

/**
 * То же самое, что SelectValueCatalog, но value представляет только id (а не {id, label})
 */
export const SelectValueCatalogId: React.FC<PropsSelectValueCatalogId> = (
  props,
) => {
  const { value, onChange, ...restProps } = props;
  const [extValue, setExtValue] = React.useState<ZSidLabel | null | undefined>(
    undefined,
  );
  const cache = React.useRef<Record<string, string>>({});
  const handleChange = (newValue?: ZSidLabel | null) => {
    if (newValue) {
      cache.current[newValue.id] = newValue.label;
      onChange?.(newValue.id);
    } else {
      onChange?.(undefined);
    }
  };
  React.useEffect(() => {
    if (!value) {
      setExtValue(undefined);
    } else {
      const label = cache.current[value];
      if (label) {
        setExtValue({ id: value, label });
      } else {
        setExtValue({ id: value, label: value });
        const curGuard = ++lastValueGuarg;
        loadValueCatalog(value)
          .then(({ name }) => {
            cache.current[value] = name;
            if (curGuard === lastValueGuarg) {
              setExtValue({ id: value, label: name });
            }
          })
          .catch(onError);
      }
    }
  }, [value]);
  return (
    <SelectValueCatalog
      {...restProps}
      value={extValue}
      onChange={handleChange}
    />
  );
};

let lastValueGuarg = 0;
